// All current base-64 implementations in the dependency tree are the standard base64
// implementation, we want the URL-safe version to avoid hitting the dumb API Gateway v2
// extra URL-decoding on the path. It's a trivial enough implementation that it's about
// as easy to just write it rather than wrap an existing implementation, and provide
// a standard implementation at the same time.
// Replace with https://github.com/tc39/proposal-arraybuffer-base64 when it's available
export default class Base64 {
  static STANDARD = new Base64("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", "=");
  static URL_SAFE = new Base64("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_", "");

  alphabet: string;
  padding: string;

  constructor(alphabet: string, padding: string) {
    this.alphabet = alphabet;
    this.padding = padding;
  }

  encode(bytes: Uint8Array): string {
    let result = "";
    for (let i = 0; i < bytes.length; i += 3) {
      // Note this abuses the fact that the undefined values returned off the end
      // of the Uint8Array have bit-wise operations performed on them that treat
      // undefined as 0, which is what we want.
      const chunk = (bytes[i] << 16) | (bytes[i + 1] << 8) | bytes[i + 2];
      result += this.alphabet[(chunk >> 18) & 0x3f];
      result += this.alphabet[(chunk >> 12) & 0x3f];
      result += this.alphabet[(chunk >> 6) & 0x3f];
      result += this.alphabet[chunk & 0x3f];
    }
    switch (bytes.length % 3) {
      case 1:
        return result.slice(0, -2) + this.padding + this.padding;
      case 2:
        return result.slice(0, -1) + this.padding;
      default:
        return result;
    }
  }
}
